// extracted by mini-css-extract-plugin
export default {"input":"javaVersionsTable_input__p8YWm","main":"javaVersionsTable_main__k0FF-","header":"javaVersionsTable_header__ZgJ-9"};